import React, { Fragment, useState, useEffect, useContext } from 'react'

import AppContext from '../contexts/AppContext'
import Message from './Message'

import { Link } from 'react-router-dom'


const ServerError = ({ match, history }) => (
    <Message
    	history={history}
        title="Server Error"
        description="An error occurred on the server. Please check back later."
        action={{to: '/', label: 'Home page'}}
    />
)

export default ServerError
